import React from 'react';
import { Box, Button, Typography } from '@heycater/design-system';
import { Grid } from '@material-ui/core';
import styled from 'styled-components';

import SectionImage from 'static_pages/marketing_pages/components/SectionImage';

function PageSectionC({ header, subtitle, content, cta, link }) {
  return (
    <Box mb={{ xs: 6, sm: 10 }}>
      <Box textAlign="center" px={{ xs: 0, sm: 5, md: 12 }}>
        <Typography
          variant="h3"
          mt={4}
          px={{ xs: 0, sm: 5, md: 0 }}
          xs={{ lineHeight: 1.5 }}
        >
          {header}
        </Typography>
        <Typography variant="body1" mt={3} mb={6}>
          {subtitle}
        </Typography>
      </Box>

      <StyledGrid container spacing={{ xs: 0, sm: 2 }}>
        {content.map((contentPart) => (
          <Grid item md={4} sm={6} xs={12} key={content.objectID}>
            <Typography variant="h5" pb={2} textAlign="center">
              {contentPart.fields.title}
            </Typography>

            <Box pb={2} width="350px" margin="0 auto">
              {contentPart.fields.image && (
                <SectionImage
                  width={379}
                  height={253}
                  {...contentPart.fields.image}
                />
              )}
            </Box>
          </Grid>
        ))}
      </StyledGrid>

      <Box mt={{ xs: 3, sm: 5 }} textAlign="center">
        <Button
          size="lg"
          rounded
          id="sectionC-button"
          as="a"
          href={link}
          target="_blank"
        >
          {cta}
        </Button>
      </Box>
    </Box>
  );
}

const StyledGrid = styled(Grid)`
  justify-content: center;
`;

export default PageSectionC;
